import { ResetPasswordForm } from '@/features/auth/components/ResetPasswordForm';
import { Toaster } from 'sonner';

export function ResetPassword() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <ResetPasswordForm />
      <Toaster position="top-right" />
    </div>
  );
}
